import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import PopupViewToggle from "../menu/PopupViewToggle";
import { PageIds } from "../PageIds";

export default class CloseSkillTreePopupView extends ParentView {
    /**
     * 
     * @param {string} parentId 
     * @param {PopupViewController} popupViewController 
     */
    constructor(parentId, popupViewController) {
        super(parentId, PageIds.CLOSE_SKILL_TREE_POPUP);

        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_skill', popupViewController, PageIds.SKILL_TREE_GRAPH, 'Close Skill Tree'));
    }

    /**
     * @override
     */
    initializeView() {

        const parent = Page.getElement(this.parentId);
        Page.createElement('div', parent, this.getElementId(), 'popup-window-close-skill-tree');

        this.setInitialVisibility(false);

        super.initializeView();
    }

}